import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Star = ({ color = '#8BD2D7', ...rest }: Props) => {
  return (
    <Svg
      width={32}
      height={33}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect y="0.5" width="32" height="32" rx="16" fill={color} />
      <path
        d="M16.8156 9.10531L18.6739 12.8312C18.808 13.1022 19.0694 13.2908 19.3727 13.3353L23.5353 13.9416C23.7801 13.9759 24.0008 14.1047 24.1487 14.2994C24.2965 14.4941 24.3594 14.7387 24.3233 14.979C24.2945 15.1782 24.2006 15.3628 24.0557 15.505L21.0377 18.4273C20.8167 18.6339 20.7161 18.9358 20.7701 19.2309L21.5135 23.3439C21.5956 23.836 21.2673 24.3038 20.7701 24.4032C20.5667 24.4352 20.3582 24.4019 20.1755 24.3083L16.4588 22.3723C16.1836 22.2332 15.8569 22.2332 15.5817 22.3723L11.865 24.3083C11.4072 24.5518 10.8352 24.3851 10.5865 23.9357C10.4922 23.7558 10.4584 23.5512 10.4898 23.3512L11.2332 19.2382C11.2872 18.9431 11.1866 18.6412 10.9656 18.4346L7.94762 15.5123C7.77057 15.3407 7.6709 15.1065 7.6709 14.8621C7.6709 14.6177 7.77057 14.3835 7.94762 14.2119C8.09025 14.0668 8.27911 13.974 8.48282 13.9489L12.6455 13.3426C12.9488 13.2981 13.2102 13.1095 13.3442 12.8385L15.1357 9.10531C15.2923 8.78687 15.6232 8.58717 15.9831 8.59392H16.0946C16.4077 8.63296 16.6792 8.82555 16.8156 9.10531Z"
        fill="white"
      />
      <path
        d="M16.0053 22.2623C15.8425 22.2612 15.6894 22.3148 15.5446 22.3879L11.8396 24.3191C11.3953 24.543 10.831 24.3631 10.5864 23.9352C10.4917 23.7581 10.4578 23.5557 10.4898 23.3581L11.2331 19.2523C11.283 18.9554 11.1832 18.6531 10.9655 18.4414L7.94012 15.5192C7.5753 15.1599 7.5753 14.5781 7.94012 14.2188C8.08282 14.0778 8.26783 13.9856 8.46789 13.9558L12.6454 13.3421C12.9674 13.2954 13.1974 13.1174 13.3442 12.838L15.159 9.06207C15.2973 8.7549 15.7622 8.54263 16.0127 8.59346C16.0053 8.84185 16.0053 22.0942 16.0053 22.2623Z"
        fill="white"
      />
    </Svg>
  )
}

export default Star
